import { useMutation } from "@tanstack/react-query";
import { OvertimeAPI } from "../api";

export const useCreateOvertimeRequest = () => {
  return useMutation({
    mutationFn: ({
      shiftDate,
      otType,
      otStart,
      otEnd,
      totalOtMinutes,
      reason,
      mediaID,
    }) =>
      OvertimeAPI.createOvertimeRequest({
        shiftDate,
        otType,
        otStart,
        otEnd,
        totalOtMinutes,
        reason,
        mediaID,
      }),
    onError: (error) => {
      console.error(
        "Create Overtime Request Failed: ",
        error.response || error
      );
    },
  });
};
export const useGetAllOvertimeRequestsPaginated = () => {
  return useMutation({
    mutationFn: ({ page, pageSize, filters }) =>
      OvertimeAPI.getAllOvertimeRequestsPaginated({ page, pageSize, filters }),
    onError: (error) => {
      console.error(
        "Get All Overtime Requests Failed: ",
        error.response || error
      );
    },
  });
};
